<template>
  <v-row no-gutters class="mt-1">
    <v-col>
      <v-data-table
          :headers="signersHeaders"
          id="signers_table__firmantes__table"
          :items="signers"
          :no-data-text="signersNoDataText"
          hide-default-footer
          dense
      >
        <template v-slot:item.actions="{ item }">
          <v-icon small @click="deleteItem(item)">{{ icon.close }}</v-icon>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
import { mdiCloseCircle } from '@mdi/js'
import {
  signersStoreData,
  signersStoreActions
} from '@/modules/signers/store/signersStoreHelpers'

export default {
  name: 'SignersTable',
  data(){
    return {
      icon: {
        close: mdiCloseCircle
      }
    }
  },
  computed: {
    ...signersStoreData
  },
  methods: {
    ...signersStoreActions,
    deleteItem(item) {
      this.removeSigner(item.id)
    }
  }
}
</script>

